// ABOUTME: Filter controls for the citation search pane — inclusion state + tags.
// ABOUTME: Default state filter is Included (I). Tag filter is OR across selected tags.

import React from 'react';
import { Dropdown, Option, Input } from '@fluentui/react-components';

export const STATE_OPTIONS = [
    { value: 'I', label: 'Included' },
    { value: 'M', label: 'Maybe' },
    { value: 'E', label: 'Excluded' },
];

export const DEFAULT_STATES = ['I'];

export const FilterBar = ({
    states, tagIds, tags, deviceIds = [], devices = [], year = '',
    onChangeStates, onChangeTagIds, onChangeDeviceIds, onChangeYear, disabled,
}) => {
    const selectedStateLabels = STATE_OPTIONS
        .filter(o => states.includes(o.value))
        .map(o => o.label)
        .join(', ');

    const selectedTagLabels = tags
        .filter(t => tagIds.includes(String(t.id)))
        .map(t => t.name)
        .join(', ');

    const selectedDeviceLabels = devices
        .filter(d => deviceIds.includes(String(d.id)))
        .map(d => d.device_name || d.name)
        .join(', ');

    const styles = {
        bar: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            padding: '6px 12px 4px',
            background: 'linear-gradient(180deg, #FFFFFF 0%, #F9FAFC 100%)',
            borderBottom: '1px solid var(--Gray-50)',
        },
        field: {
            flex: 1,
            minWidth: 0,
        },
        dropdown: {
            width: '100%',
            minWidth: 0,
        },
    };

    return (
        <div style={styles.bar}>
            <div style={styles.field}>
                <Dropdown
                    multiselect
                    appearance="filled-lighter"
                    size="small"
                    style={styles.dropdown}
                    positioning={{ position: 'below', align: 'start', autoSize: 'always', pinned: true }}
                    placeholder="Status"
                    value={selectedStateLabels || 'Status'}
                    selectedOptions={states}
                    disabled={disabled}
                    onOptionSelect={(_, data) => onChangeStates(data.selectedOptions)}
                >
                    {STATE_OPTIONS.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Dropdown>
            </div>
            <div style={styles.field}>
                <Dropdown
                    multiselect
                    appearance="filled-lighter"
                    size="small"
                    style={styles.dropdown}
                    positioning={{ position: 'below', align: 'start', autoSize: 'always', pinned: true }}
                    placeholder={tags.length ? 'Tags' : 'No tags'}
                    value={selectedTagLabels || (tags.length ? 'Tags' : 'No tags')}
                    selectedOptions={tagIds}
                    disabled={disabled || tags.length === 0}
                    onOptionSelect={(_, data) => onChangeTagIds(data.selectedOptions)}
                >
                    {tags.map(tag => (
                        <Option key={tag.id} value={String(tag.id)}>{tag.name}</Option>
                    ))}
                </Dropdown>
            </div>
            <div style={styles.field}>
                <Dropdown
                    multiselect
                    appearance="filled-lighter"
                    size="small"
                    style={styles.dropdown}
                    positioning={{ position: 'below', align: 'start', autoSize: 'always', pinned: true }}
                    placeholder={devices.length ? 'Devices' : 'No devices'}
                    value={selectedDeviceLabels || (devices.length ? 'Devices' : 'No devices')}
                    selectedOptions={deviceIds}
                    disabled={disabled || devices.length === 0}
                    onOptionSelect={(_, data) => onChangeDeviceIds(data.selectedOptions)}
                >
                    {devices.map(device => (
                        <Option key={device.id} value={String(device.id)}>{device.device_name || device.name}</Option>
                    ))}
                </Dropdown>
            </div>
            <div style={styles.field}>
                <Input
                    appearance="filled-lighter"
                    size="small"
                    type="number"
                    style={styles.dropdown}
                    placeholder="Year"
                    value={year}
                    disabled={disabled}
                    onChange={(_, data) => onChangeYear(data.value)}
                />
            </div>
        </div>
    );
};
